import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "UnitedHealthcare Marketplace",
  shortName: "UHC Marketplace",
  slug: "uhc-marketplace-insurance",
  seoTitle: "UnitedHealthcare Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have a UnitedHealthcare Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "UnitedHealthcare Marketplace TMS coverage, UHC Marketplace TMS therapy, UHC ACA depression treatment Florida, UHC Marketplace mental health benefits, UnitedHealthcare Marketplace SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "UnitedHealthcare offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov), often under the All Savers or UHC branded plans. These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because UHC Marketplace plans come in different metal tiers, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.uhc.com/en/shop",
  officialResourceLabel: "UnitedHealthcare Marketplace plans",
};

export const UhcMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default UhcMarketplaceInsurance;
